<div class="fcap-widget">
  <div *ngIf="loading" class="fcap-state">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ 'FLEXI_COMPLIANCE.LOADING' | translate }}</span>
  </div>

  <!-- Nothing outstanding is a positive result, so it says so. A bare
       "no records found" would read as "nothing is being tracked". -->
  <div *ngIf="!loading && !hasData" class="fcap-state fcap-state--ok">
    <i class="pi pi-check-circle"></i>
    <p>{{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.EMPTY' | translate }}</p>
  </div>

  <div *ngIf="!loading && hasData" class="fcap-body">
    <!-- Counts lead with the problems; the on-track total closes the set so
         the numbers visibly account for every open commitment. -->
    <div class="fcap-summary">
      <span class="fcap-summary__chip is-skipped" *ngIf="skippedCount > 0">
        <strong>{{ skippedCount }}</strong>
        {{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.SKIPPED_LABEL' | translate }}
      </span>
      <span class="fcap-summary__chip is-overdue" *ngIf="overdueCount > 0">
        <strong>{{ overdueCount }}</strong>
        {{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.OVERDUE_LABEL' | translate }}
      </span>
      <span class="fcap-summary__chip is-ontrack" *ngIf="onTrackCount > 0">
        <strong>{{ onTrackCount }}</strong>
        {{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.ON_TRACK_LABEL' | translate }}
      </span>
    </div>

    <!--
      Scrollable rather than truncated. Every outstanding commitment is in the
      DOM and reachable here; the card keeps a fixed height so the dashboard
      layout does not stretch with a business that has fifty of them.
    -->
    <ul class="fcap-list fcap-list--scroll"
        [attr.aria-label]="'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.TITLE' | translate"
        tabindex="0">
      <!-- Each row opens the grid focused on itself. Keyboard-reachable, since
           this is now the primary way into an action point from the dashboard. -->
      <li class="fcap-row is-clickable"
          *ngFor="let row of visibleRows"
          [ngClass]="toneClass(row)"
          role="button"
          tabindex="0"
          (click)="openActionPoints(row.actionPointId)"
          (keyup.enter)="openActionPoints(row.actionPointId)"
          [attr.title]="'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.OPEN_ROW' | translate">
        <span class="fcap-row__rail"></span>
        <div class="fcap-row__body">
          <p class="fcap-row__title">{{ row.title }}</p>
          <p class="fcap-row__meta">
            <span class="fcap-row__due" *ngIf="row.dueDate" [class.is-overdue]="row.daysOverdue > 0">
              <i class="pi pi-calendar"></i>
              {{ row.dueDate | date:'dd MMM yyyy' }}
            </span>
            <span class="fcap-row__recurrence" *ngIf="row.recurrenceType !== Recurrence.None">
              <i class="pi pi-refresh"></i>
              {{ row.recurrenceName }}
            </span>
            <!-- Who owes this, as role + person. This card is where a manager
                 finds out whether an item is theirs, so the row has to say so
                 rather than leaving them to open the grid. Shown even with no
                 name behind the role — "OHS responsible" with nobody assigned
                 is itself worth seeing. -->
            <span class="fcap-row__responsible">
              <i class="pi" [ngClass]="row.responsibleParty === Responsible.Advisor ? 'pi-user' : 'pi-briefcase'"></i>
              {{ responsibleLabelKey(row) | translate }}{{ responsibleNameSuffix(row) }}
            </span>
            <span class="fcap-row__status" *ngIf="row.status === ApStatus.InProgress">
              {{ 'FLEXI_COMPLIANCE.ACTION_POINTS_TAB.STATUS_IN_PROGRESS' | translate }}
            </span>
          </p>
          <p class="fcap-row__flags" *ngIf="row.isException">
            <span class="fcap-flag is-skipped" *ngIf="row.skippedCycles > 0">
              <i class="pi pi-exclamation-triangle"></i>
              {{ 'FLEXI_COMPLIANCE.RECURRENCE.SKIPPED_TOOLTIP' | translate:{ count: row.skippedCycles } }}
            </span>
            <span class="fcap-flag is-shifted" *ngIf="row.scheduleShifted">
              <i class="pi pi-arrow-right-arrow-left"></i>
              {{ 'FLEXI_COMPLIANCE.RECURRENCE.SHIFTED_TOOLTIP' | translate }}
            </span>
            <span class="fcap-flag is-overdue" *ngIf="row.daysOverdue > 0">
              <i class="pi pi-clock"></i>
              {{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.DAYS_OVERDUE' | translate:{ days: row.daysOverdue } }}
            </span>
          </p>
        </div>
      </li>
    </ul>

    <!-- Nothing is hidden from the list now, so this is a plain way into the
         full grid (filters, history, completion) rather than a "+N more". -->
    <button type="button" class="fcap-more" (click)="openActionPoints()">
      <span>{{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.OPEN' | translate }}</span>
      <i class="pi pi-arrow-right"></i>
    </button>
  </div>
</div>
